import $ from 'jquery';
import TabManager from "../customTabComponent/customTabComponent";

const claimProcess = {
    methods:{
        initializeClaimProcess:function(){
            $('.claim-processing__tab-container').each((idx,el)=>{
                $(el).find('.tab__content .rte-check-list li').prepend(`<span><svg aria-hidden="true" class="date_icon text-blue-400 me-4">
                                                <use
                                                  xlink:href="/etc.clientlibs/chli/clientlibs/clientlib-site/resources/images/sprite/sprite.svg#check-circle"
                                                />
                                              </svg></span>`);
            });
        },

           ButtonClickHandler: function (){
               $('.claim-processing-container').on('click', '.media_cta', function () {
                   let buttonText = $(this).text().replace(/\s+/g, ' ').trim();
                   let title = null;
                   let activeTab = $(this).closest('.claim-processing__tab-container').find('.tab__navigations .active-tab');
                   if (activeTab.length) {
                     title = activeTab.find('.item-text.fw-medium p').eq(1).text().trim();
                   }
                   var obj = claimProcess.methods.dataLayerObj(buttonText, title);
                   createDataLayer('buttonClick', obj);
               });
           },

           dataLayerObj: function (el,e) {
             var obj = {
               'articleName': "",
               'blogCategory': "",
               'blogPageCategory': "",
               'buttonText': el ? el : "",
               'pageSection': e ? e : "Claim Process Component",
               'pageType' : document.querySelector("meta[name='template']").content == 'chli-base-page-template' ? window.location.href.includes("blog") ? "Blogs" : window.location.href.substring(window.location.href.indexOf(".com/"), window.location.href.lastIndexOf('/')) === ".com" ? "Home" : "Other Pages" : "Blog Details Page",
               'planOption': "",
               'productCategory': "",
               'productName': "",
               'question': "",
               'source': "",
               'searchTerm': "",
               'videoTitle': "",
               'bannerName': "",
             };
             return obj;
           },

        init:function(){
            this.initializeClaimProcess();
            const tabmng = new TabManager('claim-process__tab');
            tabmng.init();
        }
    }
};

$(()=>{
    if($('.claim-processing__tab-container').length){
    claimProcess.methods.init();

    $('.claimsProcessing .tab__navigations--item').on('click', function(e){
      let buttonText=$(this).text().replace(/\s+/g, ' ').trim();
      let pageSection=$(this).closest('.claimsProcessing').find('h2').text().replace(/\n/g, '').trim();
      var obj = claimProcess.methods.dataLayerObj(buttonText,pageSection);
      createDataLayer('buttonClick', obj);
  });

    }
});

$(document).ready(function () {
  claimProcess.methods.ButtonClickHandler();
});
